export default __webpack_public_path__ + "static/media/payment-screen1.3f4e315f.webm";